/* eslint-disable complexity */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import cn from "classnames";
import React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
export var Flex = function(_param) {
    var alignProp = _param.align, directionProp = _param.direction, justifyProp = _param.justify, gapProp = _param.gap, flexProp = _param.flex, styleProp = _param.style, classNameProp = _param.className, asProp = _param.as, children = _param.children, ref = _param.ref, rest = _object_without_properties(_param, [
        "align",
        "direction",
        "justify",
        "gap",
        "flex",
        "style",
        "className",
        "as",
        "children",
        "ref"
    ]);
    var vars = {};
    var classNames = [];
    // Gap
    if (isResponsiveProp(gapProp)) {
        vars["--f_flex_gap_mobile"] = getSpacing(gapProp.mobileAndAbove);
        vars["--f_flex_gap_tablet"] = gapProp.tabletAndAbove != null ? getSpacing(gapProp.tabletAndAbove) : vars["--f_flex_gap_mobile"];
        vars["--f_flex_gap_desktop"] = gapProp.desktopAndAbove != null ? getSpacing(gapProp.desktopAndAbove) : vars["--f_flex_gap_tablet"];
        vars["--f_flex_gap_xlarge"] = gapProp.xLargeAndAbove != null ? getSpacing(gapProp.xLargeAndAbove) : vars["--f_flex_gap_desktop"];
        vars["--f_flex_gap_xxlarge"] = gapProp.xxLargeDesktop != null ? getSpacing(gapProp.xxLargeDesktop) : vars["--f_flex_gap_xlarge"];
        classNames.push("f_flex_variable_gap");
    } else if (gapProp != null) {
        vars["--f_flex_gap_mobile"] = getSpacing(gapProp);
        classNames.push("f_flex_single_value_gap");
    }
    // Flex
    if (isResponsiveProp(flexProp)) {
        var _flexProp_mobileAndAbove, _flexProp_tabletAndAbove, _flexProp_desktopAndAbove, _flexProp_xLargeAndAbove, _flexProp_xxLargeDesktop;
        vars["--f_flex_flex_mobile"] = (_flexProp_mobileAndAbove = flexProp.mobileAndAbove) === null || _flexProp_mobileAndAbove === void 0 ? void 0 : _flexProp_mobileAndAbove.toString();
        vars["--f_flex_flex_tablet"] = flexProp.tabletAndAbove != null ? (_flexProp_tabletAndAbove = flexProp.tabletAndAbove) === null || _flexProp_tabletAndAbove === void 0 ? void 0 : _flexProp_tabletAndAbove.toString() : vars["--f_flex_flex_mobile"];
        vars["--f_flex_flex_desktop"] = flexProp.desktopAndAbove != null ? (_flexProp_desktopAndAbove = flexProp.desktopAndAbove) === null || _flexProp_desktopAndAbove === void 0 ? void 0 : _flexProp_desktopAndAbove.toString() : vars["--f_flex_flex_tablet"];
        vars["--f_flex_flex_xlarge"] = flexProp.xLargeAndAbove != null ? (_flexProp_xLargeAndAbove = flexProp.xLargeAndAbove) === null || _flexProp_xLargeAndAbove === void 0 ? void 0 : _flexProp_xLargeAndAbove.toString() : vars["--f_flex_flex_desktop"];
        vars["--f_flex_flex_xxlarge"] = flexProp.xxLargeDesktop != null ? (_flexProp_xxLargeDesktop = flexProp.xxLargeDesktop) === null || _flexProp_xxLargeDesktop === void 0 ? void 0 : _flexProp_xxLargeDesktop.toString() : vars["--f_flex_flex_xlarge"];
        classNames.push("f_flex_variable_flex");
    } else if (flexProp != null) {
        var parts = flexProp.toString().split(" ");
        vars["--f_flex_flex_grow"] = parts[0];
        var _parts_;
        vars["--f_flex_flex_shrink"] = (_parts_ = parts[1]) !== null && _parts_ !== void 0 ? _parts_ : "1";
        var _parts_1;
        vars["--f_flex_flex_basis"] = (_parts_1 = parts[2]) !== null && _parts_1 !== void 0 ? _parts_1 : "0%";
        classNames.push("f_flex_single_value_flex_grow");
        classNames.push("f_flex_single_value_flex_shrink");
        classNames.push("f_flex_single_value_flex_basis");
    }
    // Align
    if (isResponsiveProp(alignProp)) {
        vars["--f_flex_align_mobile"] = alignProp.mobileAndAbove;
        vars["--f_flex_align_tablet"] = alignProp.tabletAndAbove != null ? alignProp.tabletAndAbove : vars["--f_flex_align_mobile"];
        vars["--f_flex_align_desktop"] = alignProp.desktopAndAbove != null ? alignProp.desktopAndAbove : vars["--f_flex_align_tablet"];
        vars["--f_flex_align_xlarge"] = alignProp.xLargeAndAbove != null ? alignProp.xLargeAndAbove : vars["--f_flex_align_desktop"];
        vars["--f_flex_align_xxlarge"] = alignProp.xxLargeDesktop != null ? alignProp.xxLargeDesktop : vars["--f_flex_align_xlarge"];
        classNames.push("f_flex_variable_align");
    } else if (alignProp != null) {
        vars["--f_flex_align_mobile"] = alignProp;
        classNames.push("f_flex_single_value_align");
    }
    // Justify
    if (isResponsiveProp(justifyProp)) {
        vars["--f_flex_justify_mobile"] = justifyProp.mobileAndAbove;
        vars["--f_flex_justify_tablet"] = justifyProp.tabletAndAbove != null ? justifyProp.tabletAndAbove : vars["--f_flex_justify_mobile"];
        vars["--f_flex_justify_desktop"] = justifyProp.desktopAndAbove != null ? justifyProp.desktopAndAbove : vars["--f_flex_justify_tablet"];
        vars["--f_flex_justify_xlarge"] = justifyProp.xLargeAndAbove != null ? justifyProp.xLargeAndAbove : vars["--f_flex_justify_desktop"];
        vars["--f_flex_justify_xxlarge"] = justifyProp.xxLargeDesktop != null ? justifyProp.xxLargeDesktop : vars["--f_flex_justify_xlarge"];
        classNames.push("f_flex_variable_justify");
    } else if (justifyProp != null) {
        vars["--f_flex_justify_mobile"] = justifyProp;
        classNames.push("f_flex_single_value_justify");
    }
    // Direction
    if (isResponsiveProp(directionProp)) {
        vars["--f_flex_direction_mobile"] = directionProp.mobileAndAbove;
        vars["--f_flex_direction_tablet"] = directionProp.tabletAndAbove != null ? directionProp.tabletAndAbove : vars["--f_flex_direction_mobile"];
        vars["--f_flex_direction_desktop"] = directionProp.desktopAndAbove != null ? directionProp.desktopAndAbove : vars["--f_flex_direction_tablet"];
        vars["--f_flex_direction_xlarge"] = directionProp.xLargeAndAbove != null ? directionProp.xLargeAndAbove : vars["--f_flex_direction_desktop"];
        vars["--f_flex_direction_xxlarge"] = directionProp.xxLargeDesktop != null ? directionProp.xxLargeDesktop : vars["--f_flex_direction_xlarge"];
        classNames.push("f_flex_variable_direction");
    } else if (directionProp != null) {
        vars["--f_flex_direction_mobile"] = directionProp;
        classNames.push("f_flex_single_value_direction");
    }
    return /*#__PURE__*/ React.createElement(asProp || "div", _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        style: _object_spread({}, vars, styleProp),
        className: cn(classNameProp, "f_flex_base", classNames)
    }), children);
};
